// Shared reveal visual: a whirling category "prize wheel" + countdown while
// drawing, then the settled prompt. Used by the director generator (card +
// projector) and the participant Promptaneer.
export default function SpinStage({
  result, spinning, countdown,
  projector = false, compact = false,
  wheelItems = [], reducedMotion = false,
}) {
  if (!result) return null;

  const catCls = projector ? "text-3xl" : "text-xl";
  const finalCls = projector ? "text-6xl lg:text-8xl" : compact ? "text-4xl" : "text-5xl";
  const ringSize = projector ? "w-40 h-40" : "w-28 h-28";
  const numCls = projector ? "text-7xl" : "text-5xl";

  // Whirling category reel (prize-wheel feel) — full-motion only.
  const useReel = spinning && !reducedMotion && wheelItems.length > 0;
  let base = wheelItems.length ? wheelItems.slice() : [result.category];
  while (base.length < 6) base = base.concat(wheelItems.length ? wheelItems : [result.category]);
  const reel = [...base, ...base, ...base];
  const rowH = projector ? "h-[4.6rem]" : "h-[3.3rem]";
  const rowTxt = projector ? "text-4xl" : "text-2xl";

  return (
    <div aria-live="polite">
      <div className={`font-runner ${catCls} uppercase tracking-widest text-[#bf6163]`}>Category: {result.category}</div>

      {spinning ? (
        useReel ? (
          <div className="mt-6 flex flex-col items-center" data-testid="spin-stage-spinning">
            <div
              className={`relative ${projector ? "w-[30rem] max-w-full" : "w-72"} overflow-hidden rounded-2xl border-2 border-[#920e12] bg-[#160d0e] wheel-mask`}
              style={{ height: projector ? "13.8rem" : "9.9rem" }}
            >
              <div className="wheel-reel-anim">
                {reel.map((name, i) => (
                  <div key={i} className={`flex items-center justify-center ${rowH} ${rowTxt} font-runner font-black uppercase tracking-wide text-[#ffdedf] px-4 text-center leading-none`}>
                    {name}
                  </div>
                ))}
              </div>
              <div className={`pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 ${rowH} border-y-2 border-[#bf6163] bg-[#920e12]/25`} aria-hidden="true" />
            </div>
            <div
              className={`mt-4 flex items-center justify-center rounded-full bg-[#920e12] text-white font-timer font-black tabular-nums ${projector ? "w-16 h-16 text-4xl" : "w-12 h-12 text-2xl"}`}
              data-testid="spin-countdown"
            >
              {countdown ?? ""}
            </div>
            <div className={`mt-2 ${projector ? "text-lg" : "text-sm"} uppercase tracking-[0.3em] font-extrabold text-[#bf6163]`}>Drawing…</div>
          </div>
        ) : (
          <div className="mt-6 flex flex-col items-center" data-testid="spin-stage-spinning">
            <div className={`relative ${ringSize}`}>
              <div
                className="absolute inset-0 rounded-full animate-spin"
                style={{ background: "conic-gradient(#920e12, #ffdedf, #bf6163, #550001, #920e12)", animationDuration: "0.7s" }}
                aria-hidden="true"
              />
              <div className="absolute inset-[7px] rounded-full bg-[#221517] flex items-center justify-center">
                <span className="font-timer font-black text-white tabular-nums" data-testid="spin-countdown">
                  <span className={numCls}>{countdown ?? ""}</span>
                </span>
              </div>
            </div>
            <div className={`mt-3 ${projector ? "text-lg" : "text-sm"} uppercase tracking-[0.3em] font-extrabold text-[#bf6163]`}>Drawing…</div>
          </div>
        )
      ) : result.scene_parts ? (
        <div className={`mt-4 space-y-${projector ? "6" : "3"} spin-pop`}>
          {result.scene_parts.map((sp, i) => (
            <div key={i}>
              <div className={`font-runner ${projector ? "text-xl" : "text-sm"} uppercase text-[#993538] font-bold`}>{sp.category}</div>
              <div className={`font-runner ${projector ? "text-5xl lg:text-7xl" : "text-3xl"} font-black text-[#ffdedf]`}>{sp.text}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="spin-pop">
          <span className="sr-only">. Prompt: </span>
          <div className={`mt-3 font-runner ${finalCls} font-black leading-none text-white`}>{result.text}</div>
          {result.paired_value && (
            <div className={`mt-4 ${projector ? "text-3xl lg:text-5xl" : "text-2xl"} text-[#ffdedf] font-semibold`}>↳ {result.paired_value}</div>
          )}
        </div>
      )}
    </div>
  );
}
